import { StyleSheet } from 'react-native-unistyles';
import { appThemes, breakpoints } from '@/theme';

type AppThemes = typeof appThemes;
type AppBreakpoints = typeof breakpoints;

declare module 'react-native-unistyles' {
  // Unistyles relies on interface augmentation here for theme typing.
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface UnistylesThemes extends AppThemes {}
  // Unistyles relies on interface augmentation here for breakpoint typing.
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface UnistylesBreakpoints extends AppBreakpoints {}
}

StyleSheet.configure({
  themes: appThemes,
  breakpoints,
  settings: {
    adaptiveThemes: false,
    CSSVars: true,
  },
});
